export class DetailsOfAuthorisedRepresentative {
  id: any;
  preOnboardingCreditorId: any;
  firstName: any;
  lastName: any;
  relationshipToCreditorId: number;
  otherRelationship: any;
  comments: string;
  nameOfCompany: any;
  nriC_FIN_PassportNo: string;
  emailAddress: string;
  accountStatus: string;
  createdOn: Date;
  createdBy: any;
  updatedBy: any;
  updatedOn: Date;
  contactDetailsOfAuthorizedRepresentative: ContactDetailsOfAuthorisedRepresentative[] = [];
  countryCode?: string;
  isDraft : boolean;
  contactNumber?: string;
  relationshipToCreditor: string;
}

export class ContactDetailsOfAuthorisedRepresentative {
  id: any;
  detailsOfAuthorisedRepresentativeId: any;
  countryCode: string;
  contactNumber: string;
  isActive: boolean;
  createdOn: Date;
  createdBy: any;
  updatedBy: any;
  updatedOn: Date;
}

export const DataConstants= {
  DuplicateContact: "One or more duplicate contact number exists. Please remove to proceed."
 };